export default "__VITE_ASSET__CNWQl2mj__"